var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _class2, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import anyTrait from "../Decorators/anyTrait";
import objectArrayTrait from "../Decorators/objectArrayTrait";
import objectTrait from "../Decorators/objectTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import ModelTraits from "../ModelTraits";
import ClusteringTraits from "./ClusteringTraits";
import FeatureInfoUrlTemplateTraits from "./FeatureInfoTraits";
import LegendOwnerTraits from "./LegendOwnerTraits";
import StyleTraits from "./StyleTraits";
import TableTraits from "./Table/TableTraits";
import UrlTraits from "./UrlTraits";
export let PerPropertyGeoJsonStyleTraits = (_dec = anyTrait({
  name: "Properties",
  description: "If the properties of a feature match these properties, then apply the style to that feature"
}), _dec2 = objectTrait({
  name: "Style",
  type: StyleTraits,
  description: "Styling rules to apply, following [simplestyle-spec](https://github.com/mapbox/simplestyle-spec)"
}), _dec3 = primitiveTrait({
  name: "Case sensitive",
  type: "boolean",
  description: "True if properties should be matched in a case sensitive fashion"
}), _class = class PerPropertyGeoJsonStyleTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "properties", _descriptor, this);
    _initializerDefineProperty(this, "style", _descriptor2, this);
    _initializerDefineProperty(this, "caseSensitive", _descriptor3, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "properties", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "style", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "caseSensitive", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _class);
export let GeoJsonTraits = (_dec4 = primitiveTrait({
  name: "Enable manual region mapping (Disabled for GeoJsonTraits)",
  description: "If enabled, there will be controls to set region column and region type.",
  type: "boolean"
}), _dec5 = primitiveTrait({
  name: "Use outline color for line features",
  description: "If enabled, TableOutlineStyleTraits will be used to color Line Features, otherwise TableColorStyleTraits will be used.",
  type: "boolean"
}), _dec6 = objectTrait({
  type: StyleTraits,
  name: "Style",
  description: "Styling rules that follow [simplestyle-spec](https://github.com/mapbox/simplestyle-spec). If defined, then `forceCesiumPrimitives` will be true. For styling MVT/protomaps - see `TableStyleTraits`"
}), _dec7 = primitiveTrait({
  type: "boolean",
  name: "Clamp to Ground",
  description: "Whether the features in this GeoJSON should be clamped to the terrain surface. If `forceCesiumPrimitives` is false, this will be `true`"
}), _dec8 = primitiveTrait({
  type: "boolean",
  name: "Force cesium primitives",
  description: "Force rendering GeoJSON features as Cesium primitives. This will be true if you are using `style`, `perPropertyStyles`, `timeProperty`, `heightProperty` or `czmlTemplate`. If undefined, geojson-vt/protomaps will be used. This will be set to true if simplestyle-spec properties are detected in over 50% of GeoJSON features, or if any MultiPoint features are found "
}), _dec9 = anyTrait({
  name: "Feature filter (by properties)",
  description: "Filter GeoJSON features by properties. If the properties of a feature match `filterByProperties`, then show that feature. All other features are hidden"
}), _dec0 = objectArrayTrait({
  name: "Per property styles",
  type: PerPropertyGeoJsonStyleTraits,
  description: "Override feature styles according to their properties. This is only supported for cesium primitives (see `forceCesiumPrimitives`)",
  idProperty: "index"
}), _dec1 = primitiveTrait({
  name: "Time property",
  type: "string",
  description: "The property of each GeoJSON feature that specifies which point in time that feature is associated with. If not specified, it is assumed that the dataset is constant throughout time. This is only supported for cesium primitives (see `forceCesiumPrimitives`). If using geojson-vt styling, use TableTraits instead (see `TableStyleTraits` and `TableTimeStyleTraits`)"
}), _dec10 = primitiveTrait({
  name: "Height property",
  type: "string",
  description: "The property of each GeoJSON feature that specifies the height. If defined, polygons will be extruded to this property (in meters) above terrain. This is only supported for cesium primitives (see `forceCesiumPrimitives`)"
}), _dec11 = anyTrait({
  name: "CZML template",
  description: "CZML template to be used to replace each GeoJSON **Point** and **Polygon/MultiPolygon** feature. Feature coordinates and properties will automatically be applied to CZML packet, so they can be used as references.\n\n    Polygon/MultiPolygon features only support the `polygon` CZML packet.\n\n    Point features support all packets except ones which require a `PositionsList` (eg `polygon`, `polyline`, ...)\n\n    If this is defined, `clampToGround`, `style`, `perPropertyStyles`, `timeProperty` and `heightProperty` will be ignored.\n\n    For example - this will render a cylinder for every point (and use the length and radius feature properties)\n      ```json\n      {\n        cylinder: {\n          length: {\n            reference: \"#properties.length\"\n          },\n          topRadius: {\n            reference: \"#properties.radius\"\n          },\n          bottomRadius: {\n            reference: \"#properties.radius\"\n          },\n          material: {\n            solidColor: {\n              color: {\n                rgba: [0, 200, 0, 20]\n              }\n            }\n          }\n        }\n      }\n      ```\n\n    For more info see Cesium's CZML docs https://github.com/AnalyticalGraphicsInc/czml-writer/wiki/CZML-Guide\n\n    The following custom properties are supported:\n    - `heightOffset: number` to offset height values (in m)"
}), _dec12 = primitiveTrait({
  type: "boolean",
  name: "Explode MultiPoints",
  description: "Replaces `MultiPoint` features with its equivalent `Point` features when `true`. This is useful for example when using Table mode which does not support `MultiPoint` features currently."
}), _dec13 = primitiveTrait({
  type: "boolean",
  name: "Disable depth test ",
  description: "If true, point features will render without depth testing so they remain visible through terrain and tiles."
}), _dec14 = objectTrait({
  type: ClusteringTraits,
  name: "clustering",
  description: "Allows to activate the clustering of entities, works only with Cesium as a viewer."
}), _class2 = class GeoJsonTraits extends mixTraits(FeatureInfoUrlTemplateTraits, LegendOwnerTraits, TableTraits, UrlTraits) {
  constructor() {
    super(...arguments);
    /** Override TableTraits which aren't applicable to GeoJsonTraits */
    _initializerDefineProperty(this, "enableManualRegionMapping", _descriptor4, this);
    _initializerDefineProperty(this, "useOutlineColorForLineFeatures", _descriptor5, this);
    _initializerDefineProperty(this, "style", _descriptor6, this);
    _initializerDefineProperty(this, "clampToGround", _descriptor7, this);
    _initializerDefineProperty(this, "forceCesiumPrimitives", _descriptor8, this);
    _initializerDefineProperty(this, "filterByProperties", _descriptor9, this);
    _initializerDefineProperty(this, "perPropertyStyles", _descriptor0, this);
    _initializerDefineProperty(this, "timeProperty", _descriptor1, this);
    _initializerDefineProperty(this, "heightProperty", _descriptor10, this);
    _initializerDefineProperty(this, "czmlTemplate", _descriptor11, this);
    _initializerDefineProperty(this, "explodeMultiPoints", _descriptor12, this);
    _initializerDefineProperty(this, "disableDepthTest", _descriptor13, this);
    _initializerDefineProperty(this, "clustering", _descriptor14, this);
  }
}, _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "enableManualRegionMapping", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "useOutlineColorForLineFeatures", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "style", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "clampToGround", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "forceCesiumPrimitives", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "filterByProperties", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class2.prototype, "perPropertyStyles", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor1 = _applyDecoratedDescriptor(_class2.prototype, "timeProperty", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "heightProperty", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "czmlTemplate", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "explodeMultiPoints", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "disableDepthTest", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, "clustering", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);